
import { SET_HISTORY_DATA } from './actionType';

const initialStata = {
  pagination: {
    per_page: 20,
    current_page: 1,
    total: 0,
    total_page: 0,
  },
  importHistoryData: [],
};

const fileImport = (state = initialStata, action) => {
  const { type, payload } = action;
  switch (type) {
    case SET_HISTORY_DATA:
      const { historyData } = payload;
      return {
        ...state,
        importHistoryData: historyData.data,
        pagination: {
          ...state.pagination,
          ...historyData.meta.pagination
        },
      };

    default:
      return state;
  }
};

export default fileImport;



// WEBPACK FOOTER //
// ./src/views/Setup/ObjectImport/flow/reducer.js